import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { fetchAssessmentById } from '@/api/slcp';
import { slcpAssessmentDetailKeys } from '@/app/(client)/slcp/-hooks/useSlcpAssessmentDetail';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/slcp/(pages)/assessments/(details)/$assessmentId',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: slcpAssessmentDetailKeys.detail(params.assessmentId),
      queryFn: () => fetchAssessmentById(params.assessmentId),
    }),
  component: lazyRouteComponent(
    () => import('../../../../-components/SlcpAssessmentDetailLayout'),
    'SlcpAssessmentDetailLayout',
  ),
});
